export default {
    API: 'https://v1delfi.api.swingbe.de/'

};
